
import React from 'react';
import { Link } from 'react-router-dom';

const TransitionIndicators: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue" id="transition-indicators">Key Transition Indicators: When to Change Your Support Model</h2>
      <p className="mb-4 text-gray-700 leading-relaxed">
        How do you know when it's time to evolve your IT support approach? Watch for these signals:
      </p>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        <div className="border border-gray-200 rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3 text-itmgmt-medium-blue">Signs to Upgrade Your Support</h3>
          <ul className="list-disc ml-5 text-gray-700 space-y-2">
            <li>Increasing frequency of IT issues</li>
            <li>Technology becoming a limitation to growth</li>
            <li><Link to="/services/cybersecurity" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue underline">Cybersecurity concerns</Link> emerging</li>
            <li>Employee complaints about technology</li>
            <li>Difficulty budgeting for variable IT costs</li>
            <li>Compliance requirements introduction</li>
          </ul>
        </div>
        <div className="border border-gray-200 rounded-lg p-5 shadow-sm">
          <h3 className="text-lg font-semibold mb-3 text-itmgmt-medium-blue">Questions to Ask Yourself</h3>
          <ul className="list-disc ml-5 text-gray-700 space-y-2">
            <li>Is IT reactive or proactive currently?</li>
            <li>How much downtime are we experiencing?</li>
            <li>What would a major IT failure cost us?</li>
            <li>Are we leveraging technology for competitive advantage?</li>
            <li>Do we have visibility into our IT health?</li>
            <li>Is our current approach scalable with our <Link to="/services/project-consulting" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue underline">business growth plans</Link>?</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default TransitionIndicators;
